'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dNext$002dError$002dObserver from "./com.raquo.airstream.common.-Internal-Next-Error-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream from "./com.raquo.airstream.common.-Single-Parent-Stream.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream from "./com.raquo.airstream.core.-Writable-Stream.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dStream from "./com.raquo.airstream.distinct.-Distinct-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
import * as $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024 from "./scala.util.control.-Non-Fatal$.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_misc_CollectStream(parent, fn) {
  this.Ei = null;
  this.Eh = false;
  this.Ej = null;
  this.Ee = null;
  this.Eg = null;
  this.El = false;
  this.yt = null;
  this.Ef = null;
  this.Ek = 0;
  this.yt = parent;
  this.Ef = fn;
  this.Ei = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Ek = ((1 + parent.dT()) | 0);
}
export { $c_Lcom_raquo_airstream_misc_CollectStream as $c_Lcom_raquo_airstream_misc_CollectStream };
$p = $c_Lcom_raquo_airstream_misc_CollectStream.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_misc_CollectStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_CollectStream() {
}
export { $h_Lcom_raquo_airstream_misc_CollectStream as $h_Lcom_raquo_airstream_misc_CollectStream };
$h_Lcom_raquo_airstream_misc_CollectStream.prototype = $p;
$p.dP = (function() {
  return this.Ei;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.Eh;
});
$p.fm = (function() {
  return this.Ej;
});
$p.ea = (function(x$1) {
  this.Eh = x$1;
});
$p.gD = (function(x$1) {
  this.Ej = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.hm = (function(observer) {
});
$p.ew = (function() {
  return this.Ee;
});
$p.ey = (function() {
  return this.Eg;
});
$p.hw = (function() {
  return this.El;
});
$p.g1 = (function(x$1) {
  this.El = x$1;
});
$p.hf = (function(x$0) {
  this.Ee = x$0;
});
$p.hg = (function(x$0) {
  this.Eg = x$0;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.yt);
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream.$f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.ho = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream.$f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.fX = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dNext$002dError$002dObserver.$f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.dT = (function() {
  return this.Ek;
});
$p.fW = (function(nextParentValue, transaction) {
  try {
    var $x_1 = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(this.Ef.j(nextParentValue));
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
      if ((!x2.k())) {
        var $x_1 = new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
        break matchResult1;
      }
      throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
    }
  }
  $x_1.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, _$1, transaction);
  })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue) => {
    if ((!nextValue.k())) {
      $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue.C(), transaction);
    }
  })));
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.yt;
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dStream.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_CollectStream = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_misc_CollectStream, "com.raquo.airstream.misc.CollectStream", ({
  gZ: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  ba: 1,
  bm: 1,
  as: 1,
  bI: 1,
  aj: 1,
  c1: 1,
  cL: 1
}));
export { $d_Lcom_raquo_airstream_misc_CollectStream as $d_Lcom_raquo_airstream_misc_CollectStream };
